import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Form,
    FormGroup,
    Option,
} from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Select from "react-select";
import Dropzone from "react-dropzone";
import classnames from "classnames";
import axios from "axios";

const Car = () => {
    const API_URL = process.env.REACT_APP_APIURL;

    const breadcrumbItems = [
        { title: "HOME", link: "/" },
        { title: "Add Car Details", link: "#" },
    ];

    const [activeTab, setActiveTab] = useState(1);
    const [selectedFiles, setSelectedFiles] = useState([])
    const [categoryId, setCategoryId] = useState([])
    console.log(selectedFiles, 'selectedFiles');

    const fetchCategories = async () => {
        try {
            const res = await fetch(`${`https://api.myhappywheels.com/api`}/category`);
            const data = await res.json();
            setCategoryId(data.allCategory); // ✅ Important: use allCategory
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchCategories()
    }, [])

    const [formData, setFormData] = useState({
        category: "",
        carName: "",
        carPrice: "",
        carModal: "",
        ownerSerial: "",
        insuranceValidity: "",
        insuranceType: "",
        noClaimBonus: "",
        registrationNumber: "",
        images: selectedFiles,
        carOverView: {
            condition: "",
            cylinders: "",
            stockNumber: "",
            fuelType: "",
            doors: "",
            year: "",
            color: "",
            seats: "",
            transmission: "",
            engineSize: "",
            // mileage: "",
            cityKmpl: "",
            highwayKmpl: "",
            driverType: ""
        },
        safety: {
            centralLocking: false,
            navigationSystem: false,
            abs: false,
            adas: false,
            esc: false,
            adaptiveCruiseControl: false,
            laneDepartureWarning: false,
            blindSpotDetection: false,
            autonomousEmergencyBraking: false,
            tpms: false,
            driverDrowsinessDetection: false,
            rearParkingSensorsAndCameras: false,
            headUpDisplay: false,
            airBags: false,
            childSafetyLock: false,
            antiPinchWindows: false
        },
        exterior: {
            frontFogLight: false,
            rainSensingWiper: false,
            rearSpoilers: false,
            sunRoof: false,
            ledHeadlights: false,
            drls: false,
            alloys: false,
            projectorHeadlamps: false,
            rearSpoiler: false,
            autoFoldableMirrors: false,
            keylessEntry: false
        },
        basic: {
            acFront: false,
            acRear: false,
            leather: false,
            navigationSystem: false,
            musicSystem: false,
            touchScreen: false,
            rearEntertainmentSystem: false,
            powerSeats: false,
            memorySeats: false,
            powerSteering: false
        }
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };


    const handleAcceptedFiles = (files) => {
        files.forEach(file => {
            file.preview = URL.createObjectURL(file);
            file.formattedSize = formatBytes(file.size);
        });

        setSelectedFiles(files);
        setFormData(prev => ({
            ...prev,
            images: files // optional if needed elsewhere
        }));
    };


    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Check if the field belongs to carOverView
        if (Object.keys(formData.carOverView).includes(name)) {
            setFormData(prev => ({
                ...prev,
                carOverView: {
                    ...prev.carOverView,
                    [name]: value
                }
            }));
        }
        // Handle top-level fields (like category)
        else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleCheckboxChange = (section, name) => (e) => {
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [name]: e.target.checked
            }
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const form = new FormData();
            console.log('formData', formData);

            const payload = {
                category: formData.category,
                carName: formData.carName,
                carPrice: formData.carPrice,
                carModal: formData.carModal,
                ownerSerial: formData.ownerSerial,
                insuranceValidity: formData.insuranceValidity,
                insuranceType: formData.insuranceType,
                noClaimBonus: formData.noClaimBonus,
                registrationNumber: formData.registrationNumber,
                carOverView: formData.carOverView,
                safety: formData.safety,
                exterior: formData.exterior,
                basic: formData.basic,
            };
            form.append("data", JSON.stringify(payload));
            // Append images
            selectedFiles.forEach((file, index) => {
                form.append("images", file); // adjust key to "images[]" if backend expects array
            });

            const response = await fetch(`${API_URL}/carSpecification`, {
                method: "POST",
                body: form // Don't set Content-Type header manually
            });

            const result = await response.json();
            console.log("Response:", result);

            setSuccess(true);
        } catch (err) {
            console.error("Error submitting form:", err);
            setError("Failed to submit form");
        } finally {
            setLoading(false);
        }
    };




    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="py-4">
                    <Breadcrumbs
                        title="Add Car details"
                        breadcrumbItems={breadcrumbItems}
                    />
                    <Card>
                        <CardBody>
                            <TabContent activeTab={activeTab}>
                                <Form onSubmit={handleSubmit}>
                                    <CardTitle className="mb-4 bg-light p-3" tag="h5">Category</CardTitle>
                                    <Col className="mb-5" md={4}>
                                        <Label for="categorySelect">Category</Label>
                                        <Input
                                            type="select"
                                            name="category"  // matches the top-level field name
                                            id="categorySelect"
                                            value={formData.category}
                                            onChange={handleInputChange}  // if using Option 1
                                            // onChange={handleTopLevelChange}  // if using Option 2
                                            required
                                        >
                                            <option value="">Select a category</option>
                                            {categoryId?.map((cat) => (
                                                <option key={cat._id} value={cat._id}>
                                                    {cat.category}
                                                </option>
                                            ))}
                                        </Input>
                                    </Col>
                                    <CardTitle className="mb-4 bg-light p-3" tag="h5">Car Overview</CardTitle>
                                    <Row className="mb-4">
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="condition">Condition</Label>
                                                <Input
                                                    type="text"
                                                    name="condition"
                                                    id="condition"
                                                    value={formData.carOverView.condition}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="carName">Car Name</Label>
                                                <Input
                                                    type="text"
                                                    name="carName"
                                                    id="carName"
                                                    value={formData.carName}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="carPrice">Car Price</Label>
                                                <Input
                                                    type="number"
                                                    name="carPrice"
                                                    id="carPrice"
                                                    value={formData.carPrice}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="carModal">Car Model</Label>
                                                <Input
                                                    type="text"
                                                    name="carModal"
                                                    id="carModal"
                                                    value={formData.carModal}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="ownerSerial">  Owner serial</Label>
                                                <Input
                                                    type="test"
                                                    name="ownerSerial"
                                                    id="ownerSerial"
                                                    value={formData.ownerSerial}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="registrationNumber">  Registration number</Label>
                                                <Input
                                                    type="text"
                                                    name="registrationNumber"
                                                    id="registrationNumber"
                                                    value={formData.registrationNumber}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="insuranceValidity">  Insurance validity</Label>
                                                <Input
                                                    type="text"
                                                    name="insuranceValidity"
                                                    id="insuranceValidity"
                                                    value={formData.insuranceValidity}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="insuranceType">  Insurance type</Label>
                                                <Input
                                                    type="text"
                                                    name="insuranceType"
                                                    id="insuranceType"
                                                    value={formData.insuranceType}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="noClaimBonus">  No claim bonus</Label>
                                                <Input
                                                    type="text"
                                                    name="noClaimBonus"
                                                    id="noClaimBonus"
                                                    value={formData.noClaimBonus}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="cylinders">Cylinders</Label>
                                                <Input
                                                    type="number"
                                                    name="cylinders"
                                                    id="cylinders"
                                                    value={formData.carOverView.cylinders}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="stockNumber">Stock Number</Label>
                                                <Input
                                                    type="text"
                                                    name="stockNumber"
                                                    id="stockNumber"
                                                    value={formData.carOverView.stockNumber}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="fuelType">Fuel Type</Label>
                                                <Input
                                                    type="text"
                                                    name="fuelType"
                                                    id="fuelType"
                                                    value={formData.carOverView.fuelType}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="doors">Doors</Label>
                                                <Input
                                                    type="number"
                                                    name="doors"
                                                    id="doors"
                                                    value={formData.carOverView.doors}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="year">Year</Label>
                                                <Input
                                                    type="number"
                                                    name="year"
                                                    id="year"
                                                    value={formData.carOverView.year}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="color">Color</Label>
                                                <Input
                                                    type="text"
                                                    name="color"
                                                    id="color"
                                                    value={formData.carOverView.color}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="seats">Seats</Label>
                                                <Input
                                                    type="number"
                                                    name="seats"
                                                    id="seats"
                                                    value={formData.carOverView.seats}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="transmission">Transmission</Label>
                                                <Input
                                                    type="text"
                                                    name="transmission"
                                                    id="transmission"
                                                    value={formData.carOverView.transmission}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="engineSize">Engine Size</Label>
                                                <Input
                                                    type="text"
                                                    name="engineSize"
                                                    id="engineSize"
                                                    value={formData.carOverView.engineSize}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        {/* <Col md={4}>
                                            <FormGroup>
                                                <Label for="mileage">Mileage</Label>
                                                <Input
                                                    type="number"
                                                    name="mileage"
                                                    id="mileage"
                                                    value={formData.carOverView.mileage}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col> */}
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="cityKmpl">City KMPL</Label>
                                                <Input
                                                    type="number"
                                                    name="cityKmpl"
                                                    id="cityKmpl"
                                                    value={formData.carOverView.cityKmpl}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="highwayKmpl">Highway KMPL</Label>
                                                <Input
                                                    type="number"
                                                    name="highwayKmpl"
                                                    id="highwayKmpl"
                                                    value={formData.carOverView.highwayKmpl}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="driverType">Driver Type</Label>
                                                <Input
                                                    type="text"
                                                    name="driverType"
                                                    id="driverType"
                                                    value={formData.carOverView.driverType}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row className="mb-4">
                                        <CardTitle className="mb-5 bg-light p-3" tag="h5">Safety</CardTitle>
                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="centralLocking"
                                                        checked={formData.safety.centralLocking}
                                                        onChange={handleCheckboxChange('safety', 'centralLocking')}
                                                    /> Central Locking
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="navigationSystem"
                                                        checked={formData.safety.navigationSystem}
                                                        onChange={handleCheckboxChange('safety', 'navigationSystem')}
                                                    /> Navigation System
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="abs"
                                                        checked={formData.safety.abs}
                                                        onChange={handleCheckboxChange('safety', 'abs')}
                                                    /> ABS
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="adas"
                                                        checked={formData.safety.adas}
                                                        onChange={handleCheckboxChange('safety', 'adas')}
                                                    /> ADAS
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="esc"
                                                        checked={formData.safety.esc}
                                                        onChange={handleCheckboxChange('safety', 'esc')}
                                                    /> ESC
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="adaptiveCruiseControl"
                                                        checked={formData.safety.adaptiveCruiseControl}
                                                        onChange={handleCheckboxChange('safety', 'adaptiveCruiseControl')}
                                                    /> Adaptive Cruise Control
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="laneDepartureWarning"
                                                        checked={formData.safety.laneDepartureWarning}
                                                        onChange={handleCheckboxChange('safety', 'laneDepartureWarning')}
                                                    /> Lane Departure Warning
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="blindSpotDetection"
                                                        checked={formData.safety.blindSpotDetection}
                                                        onChange={handleCheckboxChange('safety', 'blindSpotDetection')}
                                                    /> Blind Spot Detection
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="autonomousEmergencyBraking"
                                                        checked={formData.safety.autonomousEmergencyBraking}
                                                        onChange={handleCheckboxChange('safety', 'autonomousEmergencyBraking')}
                                                    /> Autonomous Emergency Braking
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="tpms"
                                                        checked={formData.safety.tpms}
                                                        onChange={handleCheckboxChange('safety', 'tpms')}
                                                    /> TPMS
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="driverDrowsinessDetection"
                                                        checked={formData.safety.driverDrowsinessDetection}
                                                        onChange={handleCheckboxChange('safety', 'driverDrowsinessDetection')}
                                                    /> Driver Drowsiness Detection
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="rearParkingSensorsAndCameras"
                                                        checked={formData.safety.rearParkingSensorsAndCameras}
                                                        onChange={handleCheckboxChange('safety', 'rearParkingSensorsAndCameras')}
                                                    /> Rear Parking Sensors & Cameras
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="headUpDisplay"
                                                        checked={formData.safety.headUpDisplay}
                                                        onChange={handleCheckboxChange('safety', 'headUpDisplay')}
                                                    /> Head Up Display
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="airBags"
                                                        checked={formData.safety.airBags}
                                                        onChange={handleCheckboxChange('safety', 'airBags')}
                                                    /> Air Bags
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="childSafetyLock"
                                                        checked={formData.safety.childSafetyLock}
                                                        onChange={handleCheckboxChange('safety', 'childSafetyLock')}
                                                    /> Child Safety Lock
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="antiPinchWindows"
                                                        checked={formData.safety.antiPinchWindows}
                                                        onChange={handleCheckboxChange('safety', 'antiPinchWindows')}
                                                    /> Anti-Pinch Windows
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row className="mb-4">
                                        <CardTitle className="mb-5 bg-light p-3" tag="h5">Exterior</CardTitle>
                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="frontFogLight"
                                                        checked={formData.exterior.frontFogLight}
                                                        onChange={handleCheckboxChange('exterior', 'frontFogLight')}
                                                    /> Front Fog Light
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="rainSensingWiper"
                                                        checked={formData.exterior.rainSensingWiper}
                                                        onChange={handleCheckboxChange('exterior', 'rainSensingWiper')}
                                                    /> Rain Sensing Wiper
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="rearSpoilers"
                                                        checked={formData.exterior.rearSpoilers}
                                                        onChange={handleCheckboxChange('exterior', 'rearSpoilers')}
                                                    /> Rear Spoilers
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="sunRoof"
                                                        checked={formData.exterior.sunRoof}
                                                        onChange={handleCheckboxChange('exterior', 'sunRoof')}
                                                    /> Sun Roof
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="ledHeadlights"
                                                        checked={formData.exterior.ledHeadlights}
                                                        onChange={handleCheckboxChange('exterior', 'ledHeadlights')}
                                                    /> LED Headlights
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="drls"
                                                        checked={formData.exterior.drls}
                                                        onChange={handleCheckboxChange('exterior', 'drls')}
                                                    /> DRLs
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="alloys"
                                                        checked={formData.exterior.alloys}
                                                        onChange={handleCheckboxChange('exterior', 'alloys')}
                                                    /> Alloys
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="projectorHeadlamps"
                                                        checked={formData.exterior.projectorHeadlamps}
                                                        onChange={handleCheckboxChange('exterior', 'projectorHeadlamps')}
                                                    /> Projector Headlamps
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="rearSpoiler"
                                                        checked={formData.exterior.rearSpoiler}
                                                        onChange={handleCheckboxChange('exterior', 'rearSpoiler')}
                                                    /> Rear Spoiler
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="autoFoldableMirrors"
                                                        checked={formData.exterior.autoFoldableMirrors}
                                                        onChange={handleCheckboxChange('exterior', 'autoFoldableMirrors')}
                                                    /> Auto Foldable Mirrors
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="keylessEntry"
                                                        checked={formData.exterior.keylessEntry}
                                                        onChange={handleCheckboxChange('exterior', 'keylessEntry')}
                                                    /> Keyless Entry
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row className="mb-4">
                                        <CardTitle className="mb-5 bg-light p-3" tag="h5">Basic</CardTitle>
                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="acFront"
                                                        checked={formData.basic.acFront}
                                                        onChange={handleCheckboxChange('basic', 'acFront')}
                                                    /> AC Front
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="acRear"
                                                        checked={formData.basic.acRear}
                                                        onChange={handleCheckboxChange('basic', 'acRear')}
                                                    /> AC Rear
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="leather"
                                                        checked={formData.basic.leather}
                                                        onChange={handleCheckboxChange('basic', 'leather')}
                                                    /> Leather
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="navigationSystem"
                                                        checked={formData.basic.navigationSystem}
                                                        onChange={handleCheckboxChange('basic', 'navigationSystem')}
                                                    /> Navigation System
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="musicSystem"
                                                        checked={formData.basic.musicSystem}
                                                        onChange={handleCheckboxChange('basic', 'musicSystem')}
                                                    /> Music System
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="touchScreen"
                                                        checked={formData.basic.touchScreen}
                                                        onChange={handleCheckboxChange('basic', 'touchScreen')}
                                                    /> Touch Screen
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="rearEntertainmentSystem"
                                                        checked={formData.basic.rearEntertainmentSystem}
                                                        onChange={handleCheckboxChange('basic', 'rearEntertainmentSystem')}
                                                    /> Rear Entertainment System
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="powerSeats"
                                                        checked={formData.basic.powerSeats}
                                                        onChange={handleCheckboxChange('basic', 'powerSeats')}
                                                    /> Power Seats
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="memorySeats"
                                                        checked={formData.basic.memorySeats}
                                                        onChange={handleCheckboxChange('basic', 'memorySeats')}
                                                    /> Memory Seats
                                                </Label>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="powerSteering"
                                                        checked={formData.basic.powerSteering}
                                                        onChange={handleCheckboxChange('basic', 'powerSteering')}
                                                    /> Power Steering
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="dropzone mb-4">
                                        <CardTitle tag="h5">Product Images</CardTitle>
                                        <Dropzone onDrop={handleAcceptedFiles}>
                                            {({ getRootProps, getInputProps }) => (
                                                <div {...getRootProps()} className="dz-message needsclick py-5 text-center border rounded">
                                                    <input {...getInputProps()} />
                                                    <i className="display-4 text-muted ri-upload-cloud-2-line" />
                                                    <p className="mt-2">Drop files here or click to upload</p>
                                                </div>
                                            )}
                                        </Dropzone>
                                        <Row className="mt-3">
                                            {selectedFiles.map((f, i) => (
                                                <Col key={i} md={3} className="mb-2">
                                                    <Card>
                                                        <CardBody className="p-2 text-center">
                                                            <img
                                                                src={f.preview}
                                                                alt={f.name}
                                                                height="80"
                                                                className="img-fluid rounded mb-2"
                                                            />
                                                            <div>{f.name}</div>
                                                            <small>{f.formattedSize}</small>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Button type="submit" color="primary" disabled={loading}>
                                            {loading ? 'Submitting...' : 'Submit'}
                                        </Button>
                                    </div>

                                    {success && (
                                        <div className="alert alert-success mt-3">
                                            Car details submitted successfully!
                                        </div>
                                    )}

                                    {error && (
                                        <div className="alert alert-danger mt-3">
                                            {error}
                                        </div>
                                    )}
                                </Form>
                            </TabContent>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Car;